import * as React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

export default function NtnForm(props) {
  return (
    <Box sx={{ width: "100%" }}>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        {props.inputs.map((input) => {
          return (
            <Grid
              item
              xs={12}
              md={6}
              style={{ padding: 20, width: "100%", paddingRight: 0 }}
              key={input.name}
            >
              {input}
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}
